export default {
  methods: {
    getHero() {
      return this.$store.state.hero;
    },
    getRotaChrom() {
      return this.$store.state.rotaChrom;
    },
    getHeidolph() {
      return this.$store.state.heidolph;
    },
    getExhibitions() {
      return this.$store.state.exhibitions;
    },
    getPrivacyPolicy() {
      return this.$store.state.privacyPolicy;
    },
    getImages() {
      return this.$store.state.images;
    },
    getFooter() {
      return this.$store.state.footer;
    },
  },
};
